import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_41: FaireProductEntity = {
  token: "catalog_prod_prod-41",
  type: "product",
  name: "Wall Decor - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 44.28,
  msrpDollars: 110.7,
  sku: "PA0041",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 214,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
